import {SummaryStrip,type SummaryMetricItem} from './SummaryStrip';
import {formatDateTime} from '../dates';

/** The load time describes this read, never the freshness or acceptance of its source. */
export function WorkspaceSourceSummary({label,items,loaded,basis}:{label:string;items:readonly SummaryMetricItem[];loaded:string;basis:string}){
 return <div className="workspace-source-summary">
  <SummaryStrip mode="metric" ariaLabel={label} items={items}/>
  <details className="workspace-source-basis"><summary>Source coverage · view loaded {formatDateTime(loaded)}</summary><p>{basis}</p></details>
 </div>;
}
